import { useMemo } from 'react'
import { type IntlShape, useIntl } from 'react-intl'

import {
  type ClientSessionCustomerData,
  type ContactRequestV1,
} from '@redteclab/api/clients/bully'

import { type PersonalAdviceProduct } from '../../personal-advice'
import { useUserApiSwrSessionV1Customer } from '../../user-data'
import {
  contactFormMakeContactFormState,
  type ContactFormState,
} from '../contactFormMakeContactFormState'

const makeContactPageContactFormState = ({
  formSubject,
  intl,
  product,
  subOrderNumber,
  userData,
}: {
  formSubject?: string
  intl: IntlShape
  product?: PersonalAdviceProduct
  subOrderNumber?: string
  userData?: ClientSessionCustomerData
}): ContactFormState => {
  const initialData: ContactRequestV1 & { phoneNumber?: string } = {
    email: userData?.email ?? '',
    fcSolution: '',
    firstName: userData?.firstName ?? '',
    lastName: userData?.lastName ?? '',
    message: '',
    orderId: subOrderNumber ?? undefined,
    phoneNumber: userData?.phone ?? '',
    productCode: product?.upid,
    subject: formSubject ?? '',
  }

  return contactFormMakeContactFormState({ initialData, intl })
}

export const useInitContactFormState = ({
  formSubject,
  product,
  subOrderNumber,
}: {
  formSubject?: string
  prodId?: string
  product?: PersonalAdviceProduct
  subOrderNumber?: string
}): {
  formState: ContactFormState
  model: ContactFormState['model']
  validator: ContactFormState['model']['validator']
} => {
  const intl = useIntl()
  const { data: userData } = useUserApiSwrSessionV1Customer()

  const formState = useMemo(
    () =>
      makeContactPageContactFormState({
        formSubject,
        intl,
        product,
        subOrderNumber,
        userData,
      }),
    [formSubject, intl, product, subOrderNumber, userData],
  )

  return {
    formState,
    model: formState.model,
    validator: formState.model.validator,
  }
}
